// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useTaskManagerService = () => {
    // hooks
    const store = useStore();
    const axios = useAxios();

    const url = store.state.apiUrl;

    // methods
    const getAllTaskListByCourse = async (courseId: number): Promise<any[]> => {
        const res = await axios.get(`${url}/task-manager/list/${courseId}`);
        return res.data;
    };

    const getAllArchivedTaskListByCourse = async (courseId: number): Promise<any[]> => {
        const res = await axios.get(`${url}/task-manager/list-archived/${courseId}`);
        return res.data;
    };

    const getTaskByTypeAndId = async (taskId: number, taskType: 'geometry' | 'non-geometry'): Promise<any> => {
        const res = await axios.get(`${url}/task-manager/task/${taskType}/${taskId}`);
        return res.data;
    };

    const getArchivedTaskByTypeAndId = async (taskId: number, taskType: 'geometry' | 'non-geometry'): Promise<any> => {
        const res = await axios.get(`${url}/task-manager/task-archived/${taskType}/${taskId}`);
        return res.data;
    };

    const createNonGeometryTask = async (task: any): Promise<any> => {
        const res = await axios.post(`${url}/task-manager/task/non-geometry`, task);
        return res.data;
    };

    const updateTask = async (task: any, taskType: 'geometry' | 'non-geometry'): Promise<any> => {
        const res = await axios.put(`${url}/task-manager/task/${taskType}`, task);
        return res.data;
    };

    const updateArchivedTask = async (task: any, taskType: 'geometry' | 'non-geometry'): Promise<any> => {
        const res = await axios.put(`${url}/task-manager/task-archived/${taskType}`, task);
        return res.data;
    };

    const markTaskDoneUndone = async (id: number, taskType: string, status : 'done' | 'live' | 'archived'): Promise<any> => {
        const res = await axios.put(`${url}/task-manager/task/${taskType}/${id}`, {status});
        return res.data;
    }

    const markArchivedTaskDoneUndone = async (id: number, taskType: string, status : 'done' | 'live' | 'archived'): Promise<any> => {
        if(taskType == 'archived') return {status: false, message: "Task already archived!"}

        const res = await axios.put(`${url}/task-manager/task-archived/${taskType}/${id}`, {status});
        return {status: res.data};
    }

    const deleteTask = async (id: number, taskType: 'geometry' | 'non-geometry'): Promise<any> => {
        const res = await axios.deleteId(`${url}/task-manager/task/${taskType}/${id}`);
        return res.data;
    };

    const deleteArchivedTask = async (id: number, taskType: 'geometry' | 'non-geometry'): Promise<any> => {
        const res = await axios.deleteId(`${url}/task-manager/task-archived/${taskType}/${id}`);
        return res.data;
    };

    return {
        getAllTaskListByCourse,
        getAllArchivedTaskListByCourse,
        getTaskByTypeAndId,
        getArchivedTaskByTypeAndId,
        createNonGeometryTask,
        markTaskDoneUndone,
        markArchivedTaskDoneUndone,
        updateTask,
        updateArchivedTask,
        deleteTask,
        deleteArchivedTask,
    };
};
